export const PwaPage = {
  DisabledAndroid: 'DisabledAndroid',
  InstallDesktop: 'InstallDesktop',
  DisabledIos: 'DisabledIos',
  InstallUnavailableOnOldIos: 'InstallUnavailableOnOldIos',
  InstallSafariIos26: 'InstallSafariIos26',
  InstallSafariIos27: 'InstallSafariIos27',
  InstallOldSafari: 'InstallOldSafari',
  InstallChrome: 'InstallChrome',
  InstallYandex: 'InstallYandex',
  InstallOther: 'InstallOther',
};

export type PwaPage = Union<typeof PwaPage>;
